import * as React from "react";
import loader from "../../assets/images/loader.svg";

interface Props {
  className: string;
}

const CircularProgress = ({ className }: Props): JSX.Element => (
  <div className={`loader ${className}`}>
    <img src={loader} alt="loader" />
  </div>
);

export default CircularProgress;
